<template>
    <div v-if="isShown" class="noDataWHeight">
        <div class="noData-wrapper">
            <div class="noData-text">
                <div v-if="icon" class="noData-icon-container" v-once>
                    <IconBase :iconName="icon" :width="iconWidth" :height="iconHeight" />
                </div>
                <div class="noData-mainText font-1" :class="mainTextClass">
                    {{mainText}}
                </div>
                <div class="font-4">
                    <slot name="subText"></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import IconBase from 'components/IconBase.vue';

export default {
    name: 'NoDataOverlay',
    components: { IconBase },
    props: {
        isShown: Boolean,
        mainText: {
            type: String,
            default: 'No Data To Display'
        },
        mainTextClass: String,
        icon: String,
        iconWidth: {
            type: [Number, String],
            default: '153'
        },
        iconHeight: {
            type: [Number, String],
            default: '115'
        }
    }
};
</script>

<style scoped lang="scss">
    @import "~styles/styleGuide";
    @import "~styles/buttons";

    $noDataTextColor: $light-700;
    $chartHeight: 200px;

    .noData-wrapper{
        &.noData-smallMessage{
            min-height: 100px;
        }
        color: $noDataTextColor;
        min-height: $chartHeight;
        height: 100%;
        background: #fff;
        text-align: center;
        position: absolute;
        top:0;
        left:0;
        right:0;
        bottom:0;
        overflow: hidden;

        a{
            @include linkStyle;
        }
    }
    .noData-text{
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
    }

    .noData-mainText{
        padding-bottom: 8px;
    }

    .noDataWHeight {
        min-height: 200px;
    }

    .noData-icon-container {
        margin-bottom: 16px;
    }
</style>
